import {listify} from "radash";
import React from "react";


const PipelineInstanceValidationErrorPanel = ({errorMessageByErrorCode}) => {
    return <ul className={"space-y-4 text-red-500 list-disc list-inside dark:text-red-400"}>
        {listify(errorMessageByErrorCode, (code, message) =>
            <li key={code} className="mt-2 text-sm text-red-600 dark:text-red-500">{message}</li>
        )}
    </ul>
}

export default PipelineInstanceValidationErrorPanel